<template>
  <div
    class="ui-signingSequence-SigningSequenceSelector">
    <div class="mb-base" v-if="showTitle">
      <h3
        class="mb-lg inline">
        {{ $t('signingSequence.ui.title') }}
      </h3>
      <div class="inline ml-base">
        <a href="https://signable.help/signing-sequences-explained/" aria-label="Related help document" class="text-gray-400 text-sm">What's this?</a>
        <ArrowUpRightFromSquareIcon class="text-gray-400 text-sm ml-1" />
      </div>
    </div>
    <div
      class="flex"
      data-test="parallel">
      <VCheckbox
        :id="prefix('parallel')"
        :checked="value === 'parallel'"
        @input="updateSelection('parallel')"
        type="radio"
        radio-value="parallel"
        :data-ec="ec"
        data-et="select_parallel"
        class="flex-shrink-0"
      />
      <slot
        name="parallelLabel"
        :forId="prefix('parallel')">
        <ParallelLabel :forId="prefix('parallel')" />
      </slot>
    </div>
    <div
      class="flex mt-base"
      data-test="sequential">
      <VCheckbox
        :id="prefix('sequential')"
        :checked="value === 'sequential'"
        @input="updateSelection('sequential')"
        type="radio"
        radio-value="sequential"
        :data-ec="ec"
        data-et="select_sequential"
        class="flex-shrink-0"
      />
      <slot
        name="sequentialLabel"
        :forId="prefix('sequential')">
        <SequentialLabel :forId="prefix('sequential')" />
      </slot>
    </div>
  </div>
</template>

<script>
import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';
import ParallelLabel from '@/components/ui/signingSequence/labels/ParallelLabel.vue';
import SequentialLabel from '@/components/ui/signingSequence/labels/SequentialLabel.vue';
import { ArrowUpRightFromSquareIcon } from '@/components/icons/fontIcons';

export default {
  name: 'SigningSequenceSelector',
  components: {
    VCheckbox,
    ParallelLabel,
    SequentialLabel,
    ArrowUpRightFromSquareIcon,
  },
  props: {
    currentSelection: {
      type: String,
      required: true,
      validator(value) {
        return ['parallel', 'sequential'].includes(value);
      },
    },
    id: {
      type: String,
      required: false,
      default: 'signing_sequence',
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
    ec: {
      type: String,
      required: false,
      default: 'signingSequence',
    },
  },
  data() {
    return {
      value: this.currentSelection,
    };
  },
  watch: {
    currentSelection(newValue) {
      this.value = newValue;
    },
  },
  methods: {
    updateSelection(value) {
      this.value = value;
      this.$emit('selectionUpdated', value);
    },
    prefix(value) {
      return `${this.id}--${value}`;
    },
  },
};
</script>
